import { makeTitle } from "@/3-features/seo/head";

export const title = makeTitle("company");
